interface FooterSectionProps {
  onBlogClick?: () => void;
  onDatenschutzClick?: () => void;
  onImpressumClick?: () => void;
  /** See Navbar for semantics — called with section hash from section links. */
  onNavigateHome?: (sectionHash?: string) => void;
}

const sectionLinks = [
  { label: 'Features', id: '#features' },
  { label: 'So funktioniert es', id: '#process' },
  { label: 'Preise', id: '#pricing' },
  { label: 'FAQ', id: '#faq' },
];

export const FooterSection: React.FC<FooterSectionProps> = ({
  onBlogClick,
  onDatenschutzClick,
  onImpressumClick,
  onNavigateHome,
}) => {
  const handleSection = (hash: string) => {
    if (onNavigateHome) {
      onNavigateHome(hash);
    } else {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-top">
          <nav className="lp-footer-nav">
            {sectionLinks.map(link => (
              <a key={link.id} href={`/${link.id}`} onClick={(e) => { e.preventDefault(); handleSection(link.id); }}>
                {link.label}
              </a>
            ))}
            {onBlogClick && (
              <a href="/blog" onClick={(e) => { e.preventDefault(); onBlogClick(); }}>Blog</a>
            )}
          </nav>
          <div className="lp-footer-right">
            <div>
              <p className="lp-footer-contact-label">Du hast Fragen?</p>
              <a href="mailto:info@estage.ai" className="lp-btn-footer-contact">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                Kontaktiere uns
              </a>
            </div>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <div className="lp-footer-legal">
            <span>&copy; 2026 estage.ai</span>
            <a href="/datenschutz" onClick={(e) => { if (onDatenschutzClick) { e.preventDefault(); onDatenschutzClick(); } }}>Datenschutz</a>
            <a href="/impressum" onClick={(e) => { if (onImpressumClick) { e.preventDefault(); onImpressumClick(); } }}>Impressum</a>
            <img src="/landing/Estage_Logo_MadeinGermany1.png" alt="Made and Hosted in Germany" style={{ height: 28, width: 'auto', opacity: 0.9 }} />
          </div>
        </div>
      </div>
      <div className="lp-footer-big-logo" aria-hidden="true">
        <img src="/landing/Estage_Logo-Lockup_1.svg" alt="" />
      </div>
    </footer>
  );
};
